import { useMemo } from "preact/hooks";
import PropTypes from "prop-types";
import TTSVoicePicker from "./tts-voice-picker.jsx";

TTSPollOption.propTypes = {
  pollOption: PropTypes.object.isRequired,
  mapping: PropTypes.object.isRequired,
  onVoiceSelected: PropTypes.func,
  className: PropTypes.string,
};

export default function TTSPollOption({
  pollOption,
  mapping,
  onVoiceSelected,
  className = "mt-3 mb-4",
}) {
  const { name, id } = pollOption;

  function handleSelection({ selectedVoice, selectedVoiceIndex }) {
    onVoiceSelected({ selectedVoice, selectedVoiceIndex, id: pollOption.id });
  }

  const currentVoiceName = useMemo(() => {
    return mapping[id];
  }, [mapping, id]);

  return (
    <div className={className}>
      <TTSVoicePicker
        label={
          <div className="flex justify-between items-center w-full">
            <span className="text-gray-400">Option:</span>
            <span className="ml-1 font-bold">{name}</span>
          </div>
        }
        currentVoiceName={currentVoiceName}
        onVoiceSelected={handleSelection}
      />
    </div>
  );
}
